$( document ).ready(function() {

  // Footer sign up code
  var $footerForm = $('#mc-embedded-subscribe-form');
  var footerFormURL = $footerForm.attr('action');
  var $footerSignUpMessage = $('.mc-embedded__error');
  var $footerFormEmail = $('.mc-embedded__email');

  $footerForm.on('submit', function(e) {
    e.preventDefault();
    var data = $footerForm.serialize();
    if ($footerFormEmail.val() == "" || $footerFormEmail.val() == undefined) {
      footerSignUpMessage ('Please enter an email address.', true)
    } else {
      submitFooterSignUp(data);
    }
  });

  function submitFooterSignUp(data) {
    $.ajax({
      type: "POST",
      url: footerFormURL,
      data: data,
      dataType: 'json',
      success: function(success) {
        footerSignUpMessage (success.msg, false);
        clearSignUpEmail ();
      },
      error: function(xhr, text, error) {
        footerSignUpMessage (error.msg, true)
      }
    });
  }

  function clearSignUpEmail () {
    $footerFormEmail.val('');
  }

  function footerSignUpMessage (message, error){
    $footerSignUpMessage.html(message);
  }

    // hide mobile menu on click Html
    $('html').on("click", function(){
      if($('body').hasClass('mobile-slide')) {
        Frame.EventBus.emit('MobileSlide:close');
      }

      $('body').removeClass('mobile-slide');
    });

    // Tabs
    $('ul.dropdown-list .link-title').click(function(e){
      $(this).parent().toggleClass('active');
    });

});